import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
import { LabelContainer } from './styled';
export function MenuLabel(props) {
    const { children, action, sticky } = props;
    return (<LabelContainer $sticky={sticky}>
      <Typography $appearance="100" $fontSize="small">
        {children}
      </Typography>
      {action && <Box ml="auto">{action}</Box>}
    </LabelContainer>);
}
